const o={cameraModule:{backgroundColor:{value:"{colors.black}"}}};export{o as liveness};
